/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
import { decorate, observable, action } from "mobx";
import { toasterState } from "Components/common/toaster";
import { makeApi, URLS } from "Utils/apiURL";
import { dialerStoreData } from "Stores/DialerData";
import axios from "axios";

let cancelTokenRequest = null;

export const defaultDialerOption = {
  mute: false,
  record: false,
  call: false,
  notes: false,
  keypad: true
};

class DialerServiceStore {
  // Observables
  dialerTokenObj = null;
  voBizTokenObj = null;
  dialerDefaultNo = null;
  voBizDefaultNo = null;
  voBizPhoneList = null;
  voBizKycRecord = null;
  dialerOption = { ...defaultDialerOption };
  dialerPhoneList = null;
  dialerCallLogs = false;
  dialerCallNotes = "";
  dialerCallStatus = "";
  dialerBtnLoader = false;
  dialerCallProgress = false;
  dialerIvrKeypad = false;
  callRecordingEnabled = true;
  purchasedNumbers = [];
  deviceStatus = "";

  // Cancel Request Function

  cancelTokenHttpRequest = () => {
    if (cancelTokenRequest !== null) {
      cancelTokenRequest("cancel");
      cancelTokenRequest = null;
    }
  };

  cancelTokenCallBack = value => {
    cancelTokenRequest = value;
  };

  // Action
  setDialerTokenObj = value => {
    this.dialerTokenObj = value;
  };

  setVoBizTokenObj = value => {
    this.voBizTokenObj = value;
  };

  setDialerCallLogs = value => {
    this.dialerCallLogs = value;
  };

  setDialerOption = (obj = {}) => {
    this.dialerOption = { ...this.dialerOption, ...obj };
  };

  setDialerCallNotes = value => {
    this.dialerCallNotes = value;
  };

  setDialerCallStatus = value => {
    this.dialerCallStatus = value;
  };

  setDialerDefaultNo = value => {
    this.dialerDefaultNo = value;
  };

  setDialerStartTimer = value => {
    this.dialerCallProgress = value;
  };

  setDialerIvrKeypad = value => {
    this.dialerIvrKeypad = value;
  };

  setCallRecordingEnabled = value => {
    this.callRecordingEnabled = value;
  };

  setPurchasedNumbers = value => {
    this.purchasedNumbers = value;
  };

  setDeviceStatus = (value = "") => {
    this.deviceStatus = value;
  };

  getVoBizToken = async () => {
    try {
      console.log("[VoBiz] getVoBizToken: calling", URLS.getVoBizToken);
      const config = {
        url: URLS.getVoBizToken,
        method: "GET"
      };
      let res = await makeApi(config);
      console.log("[VoBiz] getVoBizToken: response", JSON.stringify(res?.data));
      if (res?.data && res.data.statusCode === "SUCCESS") {
        console.log("[VoBiz] getVoBizToken: SUCCESS sipUsername=", res.data.sipUsername, "sipDomain=", res.data.sipDomain, "wsServer=", res.data.wsServer);
        this.voBizTokenObj = res.data;
      } else {
        console.error("[VoBiz] getVoBizToken: non-SUCCESS response:", res?.data?.statusCode, "httpStatus:", res?.status);
        toasterState.setToastMsg(
          "Could not initialize India calling. Please try again.",
          "failure"
        );
      }
    } catch (err) {
      console.error("[VoBiz] getVoBizToken: exception", err);
    }
  };

  getVoBizPhoneNumbers = async () => {
    try {
      const config = { url: URLS.getVoBizPhoneNumbers, method: "GET" };
      let res = await makeApi(config);
      if (res?.data && res.data.statusCode === "SUCCESS") {
        const { defaultPhNumber = "purchaseNumber", phoneNumbers = [] } = res.data;
        this.voBizDefaultNo = defaultPhNumber || "purchaseNumber";
        const nums = phoneNumbers.map(p => p.number || p).filter(Boolean);
        this.voBizPhoneList = nums;
      }
    } catch (err) {
      console.error("Getting VoBiz phone numbers error", err);
    }
  };

  updateVoBizDefaultPhoneNumber = async data => {
    try {
      let config = {
        url: URLS.updateVoBizDefaultPhoneNumber,
        method: "PUT",
        data
      };
      let res = await makeApi(config);
      if (res?.data?.status === "200") {
        toasterState.setToastMsg(
          "Default India number updated successfully",
          "success"
        );
        this.voBizDefaultNo = data.ph_number;
      } else {
        toasterState.setToastMsg("Failed to update default India number", "failure");
      }
    } catch (err) {
      console.error("Update VoBiz default phone number error", err);
    }
  };

  getDailerToken = async (useTelnyx = false) => {
    try {
      let url = URLS.getDailerToken;
      if (useTelnyx) {
        url += "?useTelnyx=true";
      }
      const config = {
        url: url,
        method: "GET"
      };
      this.cancelTokenHttpRequest();
      let res = await makeApi(config, this.cancelTokenCallBack);
      if (res?.data && Object.keys(res.data).length > 0) {
        this.dialerTokenObj = res.data;
      } else {
        toasterState.setToastMsg(
          "Something went wrong. Please try again later",
          "failure"
        );
      }
    } catch (err) {
      console.error("Getting Dailer Token Error", err);
    }
  };


  getDialerPhoneList = async (isInit = true) => {
    try {
      const config = {
        url: URLS.getMyPhoneNumbers,
        method: "GET"
      };
      let res = await makeApi(config);
      if (res?.data && Object.keys(res.data).length > 0) {
        const { defaultPhNumber = "purchaseNumber", phoneNumbers = [] } =
          res.data || {};
        this.dialerDefaultNo = defaultPhNumber || "purchaseNumber";
        this.setDialerPhoneList(phoneNumbers || []);
        dialerStoreData.setMyPhoneNumbers(res?.data);
        this.updatePurchasedNumber(phoneNumbers);
      } else {
        if (isInit) {
          toasterState.setToastMsg(
            "Something went wrong. Please try again later",
            "failure"
          );
        }
      }
    } catch (err) {
      console.error("Getting Dailer Phone List Error", err);
    }
  };

  updateDefaultPhoneNumber = async data => {
    try {
      let config = {
        url: URLS.updateDefaultPhoneNumber,
        method: "PUT",
        data
      };
      let res = await makeApi(config);
      if (res?.data?.status === "200") {
        toasterState.setToastMsg(
          "Default Phone number updated successfully",
          "success"
        );
        this.dialerDefaultNo = data.ph_number;
      } else {
        dialerStoreData.showResponseMessage(res);
      }
      this.dialerBtnLoader = false;
    } catch (err) {
      console.error("Update default phone number error ", err);
    }
  };

  setDialerPhoneList = list => {
    if (list) {
      const tempArr = [];
      list.map(value => {
        if (value && value.number) {
          tempArr.push(value.number);
        }
      });
      this.dialerPhoneList = tempArr;
    }
  };

  updatePurchasedNumber = numberList => {
    const purchasedList = [];
    numberList?.length > 0 &&
      numberList.map(number => {
        const { numberType = "" } = number || {};
        if ("Purchased" === numberType) {
          purchasedList.push(number);
        }
      });
    this.setPurchasedNumbers(purchasedList);
  };

  // -------------------------------------------------------------------------
  // VoBiz Subaccount — Feature 1
  // -------------------------------------------------------------------------

  createVoBizSubAccount = async () => {
    try {
      const config = { url: URLS.voBizAddSubAccount, method: "GET" };
      const res = await makeApi(config);
      if (res?.data?.statusCode === "SUCCESS") {
        console.log("[VoBiz] subaccount created/exists subAuthId=", res.data.subAccountAuthId);
      } else {
        console.warn("[VoBiz] createVoBizSubAccount: non-SUCCESS", res?.data);
      }
    } catch (err) {
      console.error("[VoBiz] createVoBizSubAccount error", err);
    }
  };

  // -------------------------------------------------------------------------
  // VoBiz Number Management — Feature 2
  // -------------------------------------------------------------------------

  getAvailableIndiaNumbers = async (pattern = "") => {
    try {
      const url = pattern
        ? `${URLS.voBizAvailableNumbers}?pattern=${encodeURIComponent(pattern)}`
        : URLS.voBizAvailableNumbers;
      const res = await makeApi({ url, method: "GET" });
      if (res?.data?.statusCode === "SUCCESS") {
        return res.data.numbers || [];
      }
      return [];
    } catch (err) {
      console.error("[VoBiz] getAvailableIndiaNumbers error", err);
      return [];
    }
  };

  purchaseIndiaNumber = async phoneNumber => {
    try {
      const config = {
        url: URLS.voBizPurchaseNumber,
        method: "POST",
        data: { phoneNumber }
      };
      const res = await makeApi(config);
      if (res?.data?.statusCode === "SUCCESS") {
        toasterState.setToastMsg("India number purchased successfully!", "success");
        await this.getVoBizPhoneNumbers();
        return true;
      } else {
        const msg = res?.data?.message || "Failed to purchase number. Please try again.";
        toasterState.setToastMsg(msg, "failure");
        return false;
      }
    } catch (err) {
      console.error("[VoBiz] purchaseIndiaNumber error", err);
      toasterState.setToastMsg("Something went wrong. Please try again.", "failure");
      return false;
    }
  };

  releaseIndiaNumber = async phoneNumber => {
    try {
      const config = {
        url: URLS.voBizReleaseNumber,
        method: "POST",
        data: { phoneNumber }
      };
      const res = await makeApi(config);
      if (res?.data?.statusCode === "SUCCESS") {
        toasterState.setToastMsg("India number released successfully", "success");
        await this.getVoBizPhoneNumbers();
        return true;
      } else {
        const msg = res?.data?.message || "Failed to release number. Please try again.";
        toasterState.setToastMsg(msg, "failure");
        return false;
      }
    } catch (err) {
      console.error("[VoBiz] releaseIndiaNumber error", err);
      toasterState.setToastMsg("Something went wrong. Please try again.", "failure");
      return false;
    }
  };

  // -------------------------------------------------------------------------
  // VoBiz KYC — Feature 3
  // -------------------------------------------------------------------------

  submitVoBizKyc = async (documentType, documentNumber, applicantName, frontFile, backFile) => {
    try {
      const formData = new FormData();
      formData.append("documentType", documentType);
      formData.append("documentNumber", documentNumber);
      formData.append("applicantName", applicantName);
      formData.append("document", frontFile);
      if (backFile) formData.append("backDocument", backFile);

      // Use axios directly — makeApi hardcodes application/json which breaks multipart
      const res = await axios.post(URLS.voBizKycSubmit, formData, { withCredentials: true });

      if (res?.data?.statusCode === "SUCCESS") {
        toasterState.setToastMsg("KYC documents submitted successfully!", "success");
        this.voBizKycRecord = res.data;
        return res.data;
      } else {
        const msg = res?.data?.message || "KYC submission failed. Please try again.";
        toasterState.setToastMsg(msg, "failure");
        return null;
      }
    } catch (err) {
      console.error("[VoBiz] submitVoBizKyc error", err);
      toasterState.setToastMsg("Something went wrong. Please try again.", "failure");
      return null;
    }
  };

  getVoBizKycStatus = async () => {
    try {
      const config = { url: URLS.voBizKycStatus, method: "GET" };
      const res = await makeApi(config);
      if (res?.data?.statusCode === "SUCCESS" || res?.data?.statusCode === "NOT_FOUND") {
        this.voBizKycRecord = res.data;
        return res.data;
      }
      return null;
    } catch (err) {
      console.error("[VoBiz] getVoBizKycStatus error", err);
      return null;
    }
  };
}

decorate(DialerServiceStore, {
  dialerTokenObj: observable,
  voBizTokenObj: observable,
  dialerOption: observable,
  dialerPhoneList: observable,
  voBizPhoneList: observable,
  dialerCallLogs: observable,
  dialerCallNotes: observable,
  dialerDefaultNo: observable,
  voBizDefaultNo: observable,
  voBizKycRecord: observable,
  dialerCallStatus: observable,
  dialerBtnLoader: observable,
  dialerCallProgress: observable,
  dialerIvrKeypad: observable,
  deviceStatus: observable,
  setDialerTokenObj: action,
  setVoBizTokenObj: action,
  getDailerToken: action,
  getVoBizToken: action,
  getVoBizPhoneNumbers: action,
  updateVoBizDefaultPhoneNumber: action,
  createVoBizSubAccount: action,
  getAvailableIndiaNumbers: action,
  purchaseIndiaNumber: action,
  releaseIndiaNumber: action,
  submitVoBizKyc: action,
  getVoBizKycStatus: action,
  setDialerOption: action,
  getDialerPhoneList: action,
  updateDefaultNumber: action,
  setDialerCallLogs: action,
  setDialerCallNotes: action,
  setDialerCallStatus: action,
  setDialerDefaultNo: action,
  setDialerStartTimer: action,
  setDialerIvrKeypad: action,
  setDialerPhoneList: action,
  setDeviceStatus: action
});

const DialerServiceData = new DialerServiceStore();
export default DialerServiceData;
export { DialerServiceData };
